<script>
	import ScrollAnimation from '../lib/components/ScrollAnimation.svelte';
	import Products from '../lib/components/Products.svelte';
	import { onMount } from 'svelte';
	import { Modal } from '../lib/stores/modal';
	import Banner from '../lib/components/Banner.svelte';
	import ValentineCakeProducts from '../lib/components/ValentineCakeProducts.svelte';
	import OurBestSellerCakeProducts from '../lib/components/OurBestSellerCakeProducts.svelte';
	// import StartupNotification from '../lib/components/modals/StartupNotification.svelte';
	let scrollContainer, bgvideo;
	onMount(() => {
		setTimeout(() => window.scrollTo(0,0), 100);
		bgvideo.muted = true;
		bgvideo.loop = true;
		bgvideo.playsinline = true;
		bgvideo.play();
		// setTimeout(() => {
		// 	Modal.open(StartupNotification, {
		// 		title: "Free delivery"
		// 	});
		// }, 1000);
	})

	let banners = ["1.jpg", "2.jpg", "3.jpg", "4.jpg", "5.jpg", "6.jpg", "7.jpg"]
</script>
<Banner />
<div bind:this={scrollContainer} class="scroll-container">
	<section id="hero" class="d-flex flex-column justify-content-center">
		<video autoplay loop muted playsInline id="bgVideo" bind:this={bgvideo}>
			<source src="/videos/launch.webm" type="video/mp4">
			<source src="/videos/launch.mp4" type="video/mp4">
		</video>
		<!-- <div class="container">
		<div class="row justify-content-center">
			<div class="col-xl-8">
			<h1>Delicious to the last piece</h1>
			<h2>Made by hand, from scratch, with love</h2>
			</div>
		</div>
		</div> -->
		<ScrollAnimation/>
	</section><!-- End Hero -->
	<Products/>
	<!-- <ValentineCakeProducts /> -->
	<!-- <OurBestSellerCakeProducts /> -->
	<div class="info-txt-box">
		<div class="">
			<div class="d-flex new-info">
				<div class="content-box home-page-box">
					<h1>
						Lamara Patisserie
					</h1>
					<p>
						Looking to amp up any occasion without any hassle? Lamara Patisserie is here with some delightful tasting (and looking!) cakes to help you celebrate and indulge like never before.
					</p>
				</div>
				<div class="content-box home-page-box">
					<h1>
						Delivery
					</h1>
					<p>
						Now accepting online orders. We have made your celebrations easy , just order online in advance by selecting the date & time(we provide same day delivery as well) and get your goodies delivered to your doorstep or gift something special to your loved ones anywhere in Bengaluru at no additional shipping cost.
					</p>
				</div>
			</div>
		</div>
	</div>
	<div class="homepage-slider">
		<div id="carouselExampleCaptions" class="carousel slide carousel-fade" data-bs-ride="carousel">
			<div class="carousel-inner">
				{#each banners as item, i}
					<div class="carousel-item {i == 0 ? 'active' : ''}">
						<img src="/images/banners/{item}" class="d-block w-100" alt="...">
					</div>
				{/each}
			</div>
			<button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="prev">
			  <span class="carousel-control-prev-icon" aria-hidden="true"></span>
			  <span class="visually-hidden">Previous</span>
			</button>
			<button class="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="next">
			  <span class="carousel-control-next-icon" aria-hidden="true"></span>
			  <span class="visually-hidden">Next</span>
			</button>
		  </div>
	</div>
</div>
<style>
	#hero:before {
		background: none;
		/* height: 100vh; */
	}

	.carousel-control-next, .carousel-control-prev {
		background: none;
		border: none;
		font-size: 0;
	}

	.content-box {
		padding: 24px 24px;
		min-height: 180px;
		/* background: rgba(130, 130, 130, 0.3) none repeat scroll 0 0;
		border-color: rgba(255, 255, 255, 0.4) rgba(60, 60, 60, 0.4) rgba(60, 60, 60, 0.4) rgba(255, 255, 255, 0.4);
		border-image: none;
		border-radius: 25px;
		color: #444;
		box-shadow: 8px 8px 8px #888888; */
		margin-bottom: 24px;
	}

	.home-page-box {
		box-shadow: none !important;
		background:none !important;
	}
	.content-box h1 {
		font-family: var(--primary-font);
		color: #434343;
		font-size: 22px;
		text-align: left;
		margin-bottom: 24px;
	}

	.new-info {
	}

	.new-info .content-box {
		width: 50%;
		margin-right: 24px;
	}

	.new-info .content-box:last-child {
		margin-right: 0;;
	}

	@media only screen and (min-width: 320px) and (max-width: 670px) {
		.new-info {
			flex-flow: column;
		}

		.new-info .content-box {
			width: 100%;
			margin-right: 0;
			margin-bottom: 24px;
		}
	}

	.info-txt-box {
		background: rgba(130, 130, 130, 0.3) none repeat scroll 0 0;
		border-color: rgba(255, 255, 255, 0.4) rgba(60, 60, 60, 0.4) rgba(60, 60, 60, 0.4) rgba(255, 255, 255, 0.4);
		border-image: none;
		border-radius: 25px;
		color: #444;
		box-shadow: 8px 8px 8px #888888;
		margin-bottom: 40px;
		margin-right: 10px;
		margin-left: 10px;
	}
	
</style>